import Typography from '@mui/material/Typography';
import { useTranslate } from 'react-admin';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { DeleteOutlined } from '@mui/icons-material';
import DialogTemplate from '@/components/common/dialog-template/dialog-template';
import ButtonsBlock from '@/components/common/buttons-block/buttons-block';

interface Props {
    onClick?: () => void;
    onClose?: () => void;
    isLoading: boolean;
}

const RemoveFromAgencyDialog = ({ onClose, onClick, isLoading }: Props) => {
    const translate = useTranslate();
    return (
        <DialogTemplate icon={<DeleteOutlined />} title={translate('ra.action.delete')} open={true} onClose={onClose}>
            <Box display={'grid'} gap={2}>
                <Typography>{translate('errorMessages.remove_from_agency')}</Typography>

                <ButtonsBlock>
                    <Button onClick={onClose}>{translate('ra.action.cancel')}</Button>
                    <LoadingButton
                        data-cy={'confirm-delete'}
                        variant={'contained'}
                        onClick={onClick}
                        loading={isLoading}
                    >
                        {translate('ra.action.delete')}
                    </LoadingButton>
                </ButtonsBlock>
            </Box>
        </DialogTemplate>
    );
};

export default RemoveFromAgencyDialog;
